import { CircularProgress, Typography } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { HotKeys } from 'react-hotkeys';
import '../../css/cabecalho.css';
import ReactComponent from '../ReactComponent';
import FiltrosAtivos from './FiltrosAtivos';
import ToolbarPreSessao from './ToolbarPreSessao';
import PainelProcessosDetalhes from './PainelProcessosDetalhes';
import { ESTADO_DESABILITADO } from './ToggleAtualizacaoInformacoesProcesso';

class PreSessao extends ReactComponent {
    cursor = 'pointer';

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            carregarEstadoAtualizacaoInformacoesProcesso: action,
            up: action,
            down: action,
            pageUp: action,
            pageDown: action,
            home: action,
            end: action,
            toggleProcessDetailsPanel: action
        });

        props.stores.routerStore.storeRotaAtual = 'preSessaoStore';
    }

    componentDidMount() {
        this.sessaoStore.inicializarSessaoJulgamento();
        this.preSessaoStore.carregarAutoTexto();
        this.carregarEstadoAtualizacaoInformacoesProcesso();
    }

    carregarEstadoAtualizacaoInformacoesProcesso() {
        const estadoAtual = sessionStorage.getItem('atualizacaoInformacoesProcessoHabilitada');
        if (estadoAtual === ESTADO_DESABILITADO) {
            this.sessaoStore.atualizacaoInformacoesProcessoHabilitada = false;
        } else {
            this.sessaoStore.atualizacaoInformacoesProcessoHabilitada = true;
        }
    }

    searchFocus() {
        const elementNumero = document.getElementById('numero');

        if (elementNumero !== null) {
            elementNumero.focus();
        }
    }

    up = () => {
        this.preSessaoStore.expandirProcessoAnterior();
    };

    down = () => {
        this.preSessaoStore.expandirProximoProcesso();
    };

    pageUp = () => {
        this.preSessaoStore.exibirProcessoPeloIndice(this.preSessaoStore.indiceProcessoExpandido - 10);
    };

    pageDown = () => {
        this.preSessaoStore.exibirProcessoPeloIndice(this.preSessaoStore.indiceProcessoExpandido + 10);
    };

    home = () => {
        this.store.exibirProcessoPeloIndice(0);
    };

    end = () => {
        this.setTimeout(() => {
            this.store.exibirProcessoPeloIndice(this.store.processosEmExibicao.length - 1);
        });
    };

    toggleProcessDetailsPanel = () => {
        this.appStore.toggleMostrarPainelProcessosDetalhes();
    };

    render() {
        const handlers = {
            moveUp: this.up,
            moveDown: this.down,
            search: this.searchFocus,
            home: this.home,
            end: this.end,
            pageUp: this.pageUp,
            pageDown: this.pageDown,
            toggleProcessDetailsPanel: this.toggleProcessDetailsPanel
        };
        const keyMap = {
            moveUp: 'ctrl+up',
            moveDown: 'ctrl+down',
            search: 'ctrl+shift+f',
            home: 'ctrl+alt+home',
            end: 'ctrl+alt+end',
            pageUp: 'ctrl+alt+pageup',
            pageDown: 'ctrl+alt+pagedown',
            toggleProcessDetailsPanel: 'ctrl+\\'
        };
        return this.sessaoStore.carregandoSessao ||
            (this.sessaoStore.idSessaoSelecionada && !this.sessaoStore.sessaoSelecionada) ? (
            <div style={{ display: 'flex' }}>
                <CircularProgress
                    style={{ margin: '20px' }}
                    disableShrink={true}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando pré-sessão de julgamento
                </Typography>
            </div>
        ) : (
            <HotKeys
                handlers={handlers}
                keyMap={keyMap}
                style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
            >
                <ToolbarPreSessao />
                <div
                    style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
                    id="no-print"
                >
                    <FiltrosAtivos />
                    <PainelProcessosDetalhes />
                </div>
            </HotKeys>
        );
    }
}

export default inject('stores')(observer(PreSessao));
